import { useInfiniteQuery } from '@tanstack/react-query';
import { ApiCallsV2 } from '../../../../api/apiV2';
import { TASK_SEARCH } from '../../../../constants/queryKeys';
import type { SearchScope } from '../../../../api/generated/v2/generated/data-contracts';

export function useTaskSearch(query: string, scope: SearchScope, pageSize = 10) {
    return useInfiniteQuery({
        queryKey: [TASK_SEARCH, query, scope, pageSize],
        queryFn: async ({ pageParam }) => {
            const response = await ApiCallsV2.taskSearch({
                query,
                scope,
                pageSize,
                continuationToken: pageParam,
            });
            return response.data;
        },
        getNextPageParam: lastPage => lastPage.continuationToken ?? undefined,
        keepPreviousData: true,
    });
}
